import { Component, forwardRef, input } from '@angular/core';
import { ControlValueAccessor, FormControl, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'ctr-input-color',
  imports: [ReactiveFormsModule, FormsModule],
  templateUrl: './input-color.component.html',
  styleUrl: './input-color.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputColorComponent),
      multi: true,
    },
  ],
})
export class InputColorComponent implements ControlValueAccessor {
  label = input<string>();
  id = input<string>();
  colorValue?: string;

  control = new FormControl('');

  onTouched?: () => void;

  writeValue(obj: string): void {
    console.log('writeValue', obj);
    this.control.setValue(obj);
    const color = this.formatRGB(obj);
    this.colorValue = color;
  }
  registerOnChange(fn: () => void): void {
    this.control.valueChanges.subscribe(fn);
  }
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    isDisabled ? this.control.disable() : this.control.enable();
  }

  onInput() {
    this.onTouched?.();
    this.control.setValue(this.colorValue as string);
  }

  validateValue() {
    this.onTouched?.();
    const newValue = this.formatRGB(this.control.value as string);
    this.control.setValue(newValue);
    this.colorValue = newValue;
  }

  formatRGB(color: string): string {
    const hexRegex = /^#?([0-9A-F]{3}|[0-9A-F]{6})$/i;
    const match = color.match(hexRegex);
    if (match) {
      return color.startsWith('#') ? color : `#${color}`;
    } else {
      return '#000000';
    }
  }
}
